import React from 'react';

const StickyBloodOrPulseYAxis = () => (
  <div className="custom-axis-container">
    <svg className="custom-axis-svg-container">
      <g
        transform="translate(0,10)"
        className="rv-xy-plot__axis rv-xy-plot__axis--vertical"
      >
        <line
          x1="40"
          x2="40"
          y1="0"
          y2="150"
          className="rv-xy-plot__axis__line"
        />
        <g transform="translate(40, 0)" className="rv-xy-plot__axis__ticks">
          <g transform="translate(0, 150)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              0
            </text>
          </g>
          <g transform="translate(0, 135)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              20
            </text>
          </g>
          <g transform="translate(0, 120)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              40
            </text>
          </g>
          <g transform="translate(0, 105)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              60
            </text>
          </g>
          <g transform="translate(0, 90)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              80
            </text>
          </g>
          <g transform="translate(0, 75)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              100
            </text>
          </g>
          <g transform="translate(0, 60)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              120
            </text>
          </g>
          <g transform="translate(0, 45)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              140
            </text>
          </g>
          <g transform="translate(0, 30)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              160
            </text>
          </g>
          <g transform="translate(0, 15)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              180
            </text>
          </g>
          <g transform="translate(0, 0)" className="rv-xy-plot__axis__tick">
            <line
              y1="0"
              y2="0"
              x1="6"
              x2="-6"
              className="rv-xy-plot__axis__tick__line"
            />
            <text
              textAnchor="end"
              dy="0.32em"
              transform="translate(-14, 0)"
              className="rv-xy-plot__axis__tick__text"
            >
              200
            </text>
          </g>
        </g>
      </g>
    </svg>
  </div>
);

export default StickyBloodOrPulseYAxis;
